import { render, staticRenderFns } from "./MassiveAssignmentLoadFile.vue?vue&type=template&id=65d5508b&"
import script from "./MassiveAssignmentLoadFile.vue?vue&type=script&lang=js&"
export * from "./MassiveAssignmentLoadFile.vue?vue&type=script&lang=js&"
import style0 from "./MassiveAssignmentLoadFile.vue?vue&type=style&index=0&lang=css&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports